import React, { useState, useEffect } from 'react';
import { useMessages } from '../../context/MessageContext';
import MessageInbox from './MessageInbox';
import Modal from "../../utils/modalUtils";
import authApiService from '../../services/authServices'
import { Link, useLocation, useNavigate } from 'react-router-dom';

const MessageBoard = () => {


  // const { messages } = useMessages();
  const { messages, fetchMessagesForHome } = useMessages();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [showForm, setShowForm] = useState(true);
  const [recipientSuggestions, setRecipientSuggestions] = useState([]);
  const [showRecipientDropdown, setShowRecipientDropdown] = useState(false);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);

  const location = useLocation();
  const navigate = useNavigate();

  const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
  const cityId = selectedCity?.id;
  const [formData, setFormData] = useState({ subject: '', to: '', message: '', cityId: cityId });

  useEffect(() => {
    fetchMessagesForHome(); // Fetch messages when component mounts
  }, []);

  useEffect(() => {
    const replyTo = location.state?.replyTo;
    if (replyTo) {
      // Pre-fill form data for reply
      setFormData({
        subject: `Re: ${replyTo.subject || 'No Subject'}`,
        to: replyTo.poster || replyTo.sender || '',
        message: '',
        cityId: cityId,
      });
      setSelectedMessage(null); // Ensure the form is shown instead of MessageInbox
    }
  }, [location.state, cityId]);

  useEffect(() => {
    const passedMessage = location.state?.message;
    if (passedMessage) {
      setSelectedMessage(passedMessage);
    }
  }, [messages, location.state]);

  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return isNaN(d.getTime()) ? "N/A" : d.toISOString().split("T")[0];
  };
  useEffect(() => {
    if (messages.length > 0) {
      console.log("Received messages:", messages);
    }
  }, [messages]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "to") {
      setShowRecipientDropdown(true);
    }
  };

  useEffect(() => {
    const typedName = String(formData.to || "").trim();
    if (typedName.length === 0) {
      setRecipientSuggestions([]);
      setShowRecipientDropdown(false);
      setActiveSuggestionIndex(-1);
      return;
    }

    const t = setTimeout(async () => {
      try {
        const params = { q: typedName };
        if (cityId) params.cityId = cityId;
        const response = await authApiService.get("messageRecipients", params);
        const suggestions = Array.isArray(response?.data) ? response.data : [];
        setRecipientSuggestions(suggestions);
        setShowRecipientDropdown(true);
        setActiveSuggestionIndex(suggestions.length > 0 ? 0 : -1);
      } catch (error) {
        console.error("Error fetching recipient suggestions:", error);
        setRecipientSuggestions([]);
        setShowRecipientDropdown(false);
        setActiveSuggestionIndex(-1);
      }
    }, 250);

    return () => clearTimeout(t);
  }, [formData.to, cityId]);

  const selectSuggestion = (item) => {
    setFormData((prev) => ({ ...prev, to: item.name }));
    setShowRecipientDropdown(false);
    setActiveSuggestionIndex(-1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        Modal.fire({
          icon: "error",
          title: "Error",
          text: "You must be logged in to post a message",
          confirmButtonText: "OK",
          confirmButtonColor: "#addd1e"
        });
        setLoading(false);
        
        return;
      }
      // Default API & Payload
      let apiUrl = "postMessage";
      let payload = formData;
      const response = await authApiService.post(apiUrl, payload);
      if (response && response.data) {
        console.log("MessageSent successfully:", response.data);
        Modal.fire({
          icon: "success",
          title: "Message sent",
          text: "Message sent successfully.",
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: "#addd1e"
        }).then(() => {
          setFormData({ subject: '', to: '', message: '', cityId: cityId });
          setSelectedMessage(null);
          fetchMessagesForHome();
          navigate("/carter/profile");
        });
      }
    } catch (error) {
      console.error('Error sending message:', error);
      Modal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Message not sent. Please try again.",
        confirmButtonText: "OK",
        confirmButtonColor: "#addd1e"
      });
    }
    setLoading(false);
  };


  const handleCheckboxChange = (index) => {
    setSelectedMessages((prevSelected) => {
      if (prevSelected.includes(index)) {
        return prevSelected.filter((i) => i !== index);
      } else {
        return [...prevSelected, index];
      }
    });
  };


  /**
   * Handles deletion of selected messages with confirmation
   */
  const handleDelete = async () => {
    try {
      if (selectedMessages.length === 0) {
        Modal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select a message to delete.",
          confirmButtonText: "OK"
        });
        return;
      }

      const result = await Modal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#addd1e",
        cancelButtonColor: "#b38ec1",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel"
      });

      if (result.isConfirmed) {
        try {
          const payload = {
            id: selectedMessages,
          };

          const response = await authApiService.put("deletePublicMessage", payload);

          if (response.code === 200) {
            Modal.fire({
              icon: "success",
              title: "Deleted!",
              text: "Message(s) deleted successfully.",
              confirmButtonText: "OK",
              confirmButtonColor: "#addd1e"
            });
          }
          fetchMessagesForHome();
          setSelectedMessages([]);
        } catch (error) {
          console.error('Error deleting messages:', error);
          Modal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.data?.message || "Failed to delete messages. Please try again.",
            confirmButtonText: "OK",
            confirmButtonColor: "#addd1e"
          });
        }
      }
    } catch (error) {
      console.error('Error in handleDelete:', error);
    }
  };



  return (
    <div className="msgboard-section">
      <div className="row">
        <div id="inbox" className="col-sm-12">
          <div className="heading-golfer">
            <h4>PUBLIC MESSAGE BOARD</h4>
            <img src="/images/public-bd-icon.png" alt="Messages" />
          </div>
          <div className="clear" />

          <div className="tbl-msg-div shadow">
            <table cellSpacing={0} id="message" className="messages" cellPadding={0}>
              <thead>
                <tr>
                  <th />
                  <th>FROM</th>
                  <th>SUBJECT</th>
                  <th>DATE</th>
                </tr>
              </thead>
              <tbody>
                {messages.length > 0 ? (
                  messages.map((msg, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'even' : 'odd'}>
                      <td>
                        <input
                          type="checkbox"
                          onChange={() => handleCheckboxChange(index)}
                          checked={selectedMessages.includes(index)}
                        />
                      </td>
                      <td>{msg.poster ? msg.poster : msg.sender || 'Unknown'}</td>
                      <td
                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                        onClick={() => {

                          console.log('Clicked message:', msg);
                          setSelectedMessage(msg)
                        }}
                      >
                        {msg.subject || 'No Subject'}
                      </td>
                      <td>{formatDate(msg.date ? msg.date : msg.read_date) || 'N/A'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No messages found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="public-post green-post-link">
            <Link 
              to="#" 
              className="msg-post-btn mr-3"
              onClick={(e) => {
                e.preventDefault();
                setShowForm(true);
                setSelectedMessage(null);
              }}
            >
              Post a message
            </Link>
            <div className='del_btn_pg d-inline-block'>
              <Link to="#" className="squarebutton" onClick={handleDelete}>
                <span>Delete</span>
              </Link>
            </div>
          </div>

          <div className="col-12 text-right del_btn_pg">
            {/* <div className="buttonwrapper">
              <Link to="#" className="squarebutton" onClick={handleDelete}>
                <span>Delete</span>
              </Link>
            </div> */}
            <input
              type="hidden"
              id="bDelete"
              name="bDelete"
              defaultValue="false"
            />
          </div>
        </div>

        {/* Conditional Rendering: Show MessageInbox or Message Form */}
        {selectedMessage && <MessageInbox message={selectedMessage} />}
        {!selectedMessage && showForm && (
          <div id="form-div" className="col-sm-12 mb-5">
            <div className="heading-golfer">
              <h4>Write your message</h4>
              <img src="/images/public-bd-icon.png" alt="Messages" />
            </div>
            <div className="post">
              <form onSubmit={handleSubmit}>
                <div className="row d-flex">
                  <div className="col-6 align-self-stretch mb-4">
                    <div className="sub-container grey-box shadow h-100 mb-0 mgsTo">
                      <label className='pr-2' htmlFor="msgTo">To</label>
                      <div className="sub-input" style={{ position: "relative" }}>
                        <input
                          id="to"
                          name="to"
                          className="subject"
                          type="text"
                          maxLength={50}
                          value={formData.to}
                          onChange={handleChange}
                          onFocus={() => {
                            if (recipientSuggestions.length > 0) {
                              setShowRecipientDropdown(true);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (!showRecipientDropdown || recipientSuggestions.length === 0) return;

                            if (e.key === "ArrowDown") {
                              e.preventDefault();
                              setActiveSuggestionIndex((prev) => (prev + 1) % recipientSuggestions.length);
                              return;
                            }
                            if (e.key === "ArrowUp") {
                              e.preventDefault();
                              setActiveSuggestionIndex((prev) => (prev <= 0 ? recipientSuggestions.length - 1 : prev - 1));
                              return;
                            }
                            if (e.key === "Enter") {
                              e.preventDefault();
                              const item = recipientSuggestions[activeSuggestionIndex >= 0 ? activeSuggestionIndex : 0];
                              if (item) {
                                selectSuggestion(item);
                              }
                              return;
                            }
                            if (e.key === "Escape") {
                              e.preventDefault();
                              setShowRecipientDropdown(false);
                              setActiveSuggestionIndex(-1);
                            }
                          }}
                          required
                        />
                        {showRecipientDropdown && recipientSuggestions.length > 0 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              right: 0,
                              zIndex: 20,
                              background: "#fff",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              maxHeight: "220px",
                              overflowY: "auto"
                            }}
                          >
                            {recipientSuggestions.map((item) => (
                              <button
                                key={item.id}
                                type="button"
                                onClick={() => selectSuggestion(item)}
                                style={{
                                  width: "100%",
                                  textAlign: "left",
                                  border: "none",
                                  background:
                                    recipientSuggestions[activeSuggestionIndex]?.id === item.id
                                      ? "#f1f5f9"
                                      : "transparent",
                                  padding: "8px 10px",
                                  cursor: "pointer"
                                }}
                              >
                                {item.name}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-6 align-self-stretch mb-4">
                    <div className="sub-container grey-box shadow h-100  mb-0">
                      <label htmlFor="subject">Subject:</label>
                      <div className="sub-input">
                        <input
                          id="subject"
                          name="subject"
                          className="subject"
                          type="text"
                          maxLength={50}
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="msginput-container grey-box shadow sub-input">
                  <label htmlFor="msginput">Message:</label>
                  <textarea
                    id="msginput"
                    name="message"
                    className="emailMessage"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="buttons mb-5">
                  <div className="send-btn mr-2">
                    <div className="buttonwrapper">
                      <a href="#" onClick={handleSubmit} className="squarebutton">
                        <span>Send</span>
                      </a>
                    </div>
                  </div>
                  <div className="bcancel-btn">
                    <div className="buttonwrapper">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setFormData({ subject: '', to: '', message: '', cityId: cityId });
                          setRecipientSuggestions([]);
                          setShowRecipientDropdown(false);
                          setActiveSuggestionIndex(-1);
                          setSelectedMessage(null);
                          setShowForm(false);
                        }}
                        className="squarebutton"
                      >
                        <span>Cancel</span>
                      </a>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBoard;


